module.exports = __webpack_public_path__ + "static/img/14000695.c93cdb4e.png";